import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setKeepCopyState')(function setKeepCopyState(keepCopy) {
    store.keepCopy = keepCopy;
});
//# sourceMappingURL=setKeepCopyState.js.map